import { CoreHttpServiceClient } from "mongodb-stitch-core-services-http";
import HttpServiceClientImpl from "./internal/HttpServiceClientImpl";
export var HttpServiceClient;
(function (HttpServiceClient) {
    HttpServiceClient.factory = new (function () {
        function class_1() {
        }
        class_1.prototype.getNamedClient = function (service, client) {
            return new HttpServiceClientImpl(new CoreHttpServiceClient(service));
        };
        return class_1;
    }())();
})(HttpServiceClient || (HttpServiceClient = {}));
//# sourceMappingURL=HttpServiceClient.js.map